<template>
  <div v-if="show" class="asc-validation-message theme--light error--text">
    <div class="messages__wrapper">
      <div class="message">{{ message }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AscValidationMessage',
  props: {
    message: {
      type: String,
      required: true,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss">
.asc-validation-message,
.v-messages {
  flex: 1 1 auto;
  font-size: 12px;
  min-height: 12px;
  min-width: 1px;
  position: relative;

  &.error--text {
    color: $badge-red !important;
    caret-color: $badge-red !important;

    div > div {
      &::before {
        content: '\F0026';
        display: inline-block;
        font-style: normal;
        font-variant: normal;
        font-weight: normal;
        font-family: Material Design Icons, sans-serif;
        font-size: inherit;
        text-rendering: auto;
        line-height: inherit;
        -webkit-font-smoothing: antialiased;
        margin-right: 4px;
      }
    }
  }
}
</style>
